import { render, staticRenderFns } from "./selectProperty.vue?vue&type=template&id=2372a731"
import script from "./selectProperty.vue?vue&type=script&lang=js"
export * from "./selectProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports